import { MetaInfo } from "@/components/meta-info"
import { useZeroWorkspace } from "@/lib/zero"
import { SettingsHeader } from "../../settings-header"
import { EmailSetupSteps } from "../setup-steps/setup-steps"

export const EmailSetupSettingsPage = () => {
	const workspace = useZeroWorkspace()

	if (!workspace) return null

	return (
		<>
			<MetaInfo title="Email setup" />

			<SettingsHeader
				title="Email setup"
				subtitle="Configure the support email you receive and send messages with."
				docsArticle="e1e61420-452d-4bb7-82a4-ab843f79c739"
			/>
			<EmailSetupSteps workspace={workspace} />
		</>
	)
}
